export const deleteFromArr = (deleteItem, arr) => {
  const newArr = [...arr];
  const itemIndex = newArr.indexOf(newArr.find(item => item.id === deleteItem.id));
  if (~itemIndex) newArr.splice(itemIndex, 1);
  return newArr;
};